import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#CCC",
      "fill-rule": "evenodd",
      d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10M10.777 8.185c.45-.24.98-.335 1.503-.26.507.072.963.297 1.301.626.368.464.52.816.52 1.208 0 .228-.112.489-.406.788s-.699.562-1.093.768c-.82.428-1.5 1.286-1.5 2.351a.9.9 0 0 0 1.8 0c0-.26.178-.57.534-.756.476-.249 1.063-.613 1.543-1.101.479-.488.923-1.177.923-2.05 0-.99-.44-1.744-.95-2.376a1 1 0 0 0-.06-.066 4.13 4.13 0 0 0-2.357-1.174 4.26 4.26 0 0 0-2.586.444c-.835.396-1.397 1.134-1.74 1.77a.9.9 0 0 0 1.585.854c.254-.471.584-.839.937-1.002zm1.225 7.915a.9.9 0 0 0 0 1.8h.015a.9.9 0 1 0 0-1.8z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }